"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![EntityIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IndoaXRlIiB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzNjAgMzYwIj4KICA8cGF0aCBkPSJNMzIwLDMwMC4xODdsLTI4MCwwbDAsLTI0MGw4NSwwbDAsMGwyMCwwbDAsMGw3MCwwbDAsMGwyMCwwbDAsMGw4NSwwbDAsMjQwWm0tMTk1LC0yMGwwLC02MWwtNjUsMGwwLDYxbDY1LDBabTIwLC02MWwwLDYxbDcwLDBsMCwtNjFsLTcwLDBabTE1NSwwbC02NSwwbDAsNjFsNjUsMGwwLC02MVptLTI0MCwtNzlsMCw1OWw2NSwwbDAsLTU5bC02NSwwWm04NSwwbDAsNTlsNzAsMGwwLC01OWwtNzAsMFptOTAsMGwwLDU5bDY1LDBsMCwtNTlsLTY1LDBaIiAvPgo8L3N2Zz4=)
 */
exports.EntityIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 360 360", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M320 300.187H40v-240h280v240zm-195-20v-61H60v61h65zm20-61v61h70v-61h-70zm155 0h-65v61h65v-61zm-240-79v59h65v-59H60zm85 0v59h70v-59h-70zm90 0v59h65v-59h-65z" })));
};
//# sourceMappingURL=Icon.Entity.js.map